import { gql } from 'graphql-request';

import {
  GlobalCompanyTabCompanyType,
  GlobalCompanyTabCreatedAt,
  GlobalCompanyTabID,
  GlobalCompanyTabName,
  GlobalCompanyTabNanoID,
  GlobalCompanyTabPosition,
  GlobalCompanyTabRole,
  GlobalCompanyTabType,
  GlobalCompanyTabUpdatedAt,
  GlobalCompanyTabUser,
  GlobalCompanyTabUserID,
  GlobalCompanyTabUUID
} from '../globalCompanyTabsTypes';

export interface FetchGlobalCompanyTabsQueryResponse {
  id: GlobalCompanyTabID;
  uuid: GlobalCompanyTabUUID;
  nanoId: GlobalCompanyTabNanoID;
  name: GlobalCompanyTabName;
  content: string | null;
  position: GlobalCompanyTabPosition;
  type: GlobalCompanyTabType;
  companyType: GlobalCompanyTabCompanyType;
  createdAt: GlobalCompanyTabCreatedAt;
  updatedAt: GlobalCompanyTabUpdatedAt;
  userId: GlobalCompanyTabUserID;
  user: GlobalCompanyTabUser;
  roles: GlobalCompanyTabRole[];
}

export const FETCH_GLOBAL_COMPANY_TABS_QUERY = gql`
  query GlobalCompanyTabs(
    $filters: GlobalCompanyTabsFilters
    $limit: Int
    $offset: Int
    $sort: [GlobalCompanyTabsSortEnum!]
  ) {
    globalCompanyTabs(
      filters: $filters
      limit: $limit
      offset: $offset
      sort: $sort
    ) {
      nodes {
        companyType
        content
        createdAt
        id
        name
        nanoId
        position
        type
        updatedAt
        userId
        uuid
        user {
          id
          nanoId
        }
        roles {
          id
          name
          nanoId
          uuid
        }
      }
      paginationInfo {
        currentPage
        firstPage
        lastPage
        limitValue
        nextPage
        outOfRange
        prevPage
        totalCount
        totalPages
      }
      sql
    }
  }
`;
